<template>
    <Loading>
        <Paper class="favorite-card-root p-4 pointer d-flex flex-column align-items-center">
            <div class="image-wrapper">
                <Avatar />
            </div>
            <Row />
            <Row />
        </Paper>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Row from '~/components/skeletons/base/Row';
import Avatar from '~/components/skeletons/base/Avatar';

export default {
    name: 'FavoriteCardSkeleton',
    components: { Loading, Row, Avatar },
};
</script>

<style scoped>
.favorite-card-root:hover {
    box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.15) !important;
    transform: scale(1.02);
    transition: transform 0.2s ease-in-out;
}

.image-wrapper {
    max-width: 200px;
    max-height: 100px;
    height: 100px;
    overflow: hidden;
}

.image {
    width: 100%;
    height: 100%;
    max-height: 100px;
    object-fit: scale-down;
}
</style>
